export enum FetchErrorName {
  NetworkError = 'NetworkError',
  ParsingError = 'ParsingError',
  UnauthorizedError = 'UnauthorizedError',
  ForbiddenError = 'ForbiddenError',
}
